import React, { useEffect } from 'react';
import RatingSelector from '@/components/features/RatingSelector/RatingSelector';
import TestRatingForm from '@/components/features/TestRatingForm/TestRatingForm';
import { useDispatch, useSelector } from 'react-redux';
import { checkIsOwnAttempt, checkIsRatingSaved, checkIsVoted } from '@/store/selectors/ratingSelectors';
import { useModal } from '@/core/hooks/useModal';
import { setSelectedRating } from '@/store/reducers/testRatingSlice';

interface RatingWithModalProps {
}


const RatingWithModal: React.FC<RatingWithModalProps> = ({  }) => {
	const isRatingSaved = useSelector(checkIsRatingSaved);
	const isOwnAttempt = useSelector(checkIsOwnAttempt);
	const isVoted = useSelector(checkIsVoted);

	const { show: showRatingForm, RenderModal, hide } = useModal();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setSelectedRating(0));
	}, [dispatch]);

	return (
		<>
			<RenderModal unclosed={isRatingSaved} mode={isRatingSaved ? 'successPrompt' : ''}>
				<TestRatingForm onClose={hide} />
			</RenderModal>
			{!isRatingSaved && isOwnAttempt && !isVoted &&  (
				<div onClick={showRatingForm}>
					<RatingSelector />
				</div>
			)}
		</>
	)
}

export default RatingWithModal